export enum Category {
  all = "All",
  ver = "Version Information",
  misc = "Miscellaneous",
  app = "Applications",
  drive = "Drivers",
  doc = "Documentation",
  safeCert = "Safety Certification",
}

export type RowData = {
  name: string;
  update: Date;
  description: string;
  url: string;
  category: Category;
  renderDescription?: true;
};
